export default "__VITE_ASSET__YTkDpCP$__"